/* Utility functions for working with URL parameters */

var UrlParameter = (function () {
  
  // returns GET parameter from url by name
  var get = function (url, name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(url);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  };

  // Add / Update a key-value pair in the URL query parameters
  var update = function (url, name, value) {

      // remove the hash part before operating on the uri
      var i = url.indexOf('#');
      var hash = i === -1 ? ''  : url.substr(i);
           url = i === -1 ? url : url.substr(0, i);

      var re = new RegExp("([?&])" + name + "=.*?(&|$)", "i");
      var separator = url.indexOf('?') !== -1 ? "&" : "?";
      if (url.match(re)) {
          url = url.replace(re, '$1' + name + "=" + value + '$2');
      } else {
          url = url + separator + name + "=" + value;
      }
      return url + hash;  // finally append the hash as well
  };

  // removes GET parameter from url by name
  var remove = function (url, name) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');   
    if (urlparts.length >= 2) {

      var prefix = encodeURIComponent(name) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0;) {    
        // idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
          pars.splice(i, 1);
        }
      }

      url = urlparts[0];
      return url;
    } else {
      return url;
    }
  };

  return {
    get: get,
    update: update,
    remove: remove
  };

}());

